import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
// Interfaces
import {
	IService,
	IApplicationModel,
	IContact, IStepModel, IQuestion, IQuestionModel, IQuestionsModel, IAWSS3, IAWSS3Model, IModel
} from '../../interfaces';
// classes
import { ApplicationCreateForm, ApplicationForm, ApplicationModel, ApplicationStatus } from '../../classes';
// Enums
import { ApplicationStatusEnum } from '../../enums';
// Services

import { LogService} from '../../services/log/log.service';
import { ServerService} from '../../services/server/server.service';
import { HelperService} from '../../services/helper/helper.service';
import { UserService} from '../../services/user/user.service';
import { StorageService} from '../../services/storage/storage.service';


@Injectable()
export class FileService implements IService {
	// implements local variables
	questions: IQuestionsModel;

	// implements IService
	name = 'FileService';
	test(name, value) {
		console.log('testing', name, value);
	}

	constructor(
		private _logSrv: LogService,
		private _userSrv: UserService,
		private _serverSrv: ServerService,
		private _helperSrv: HelperService,
		private _storageSrv: StorageService
	) { }

	get(applicationNumber: string, fileName: string, refresh = false): Promise<IAWSS3Model> {
		if (refresh) {
			this._storageSrv.RemoveKey(this._storageSrv.KEY_S3);
		}
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_S3);
		const endPoint = this._helperSrv.ApiLocation +
			`AWS/S3/get/application/${applicationNumber}/file/${fileName}/key/${key}`;
		return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, endPoint)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IAWSS3Model>body.Data;
					return data;
				} else {
					this._logSrv.Error(this.name, ['get file', response]);
					return undefined;
				}
			})
			.toPromise();
	}


	upload(f: File, file: IAWSS3): Promise<IAWSS3Model> {
		let fData = new FormData();
		fData.append('file', f);


		// let IData = new ImageData(200, 200);
		// IData.data = new Uint8ClampedArray(f.size);
		// 'Accept': 'application/json',
		const h = new Headers(
			{
				'Authorization': this._helperSrv.Authorization,
				'Access-Control-Allow-Origin': '*',
				'x-version': '1',
				// 'Content-Type': file.Type ,
				// 'Content-Length': f.size
			}
		);

		const options = new RequestOptions(
			{ headers: h }
		);

		const endPoint = this._helperSrv.ApiLocation +
			`AWS/S3/Upload/application/${file.ApplicationNumber}/file/${file.Name}/ext/${file.Ext}/order/${file.Order}`;
		this._logSrv.Debug(this.name, ['upload file aws s3', endPoint, fData, h, f]);
		return this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, fData, options)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IAWSS3Model>body.Data;
					return data;
				} else {
					this._logSrv.Error(this.name, ['get file', response]);
					return undefined;
				}
			})
			.toPromise();
	}


	uploadAsync(f: any, file: IAWSS3): Promise<IAWSS3Model> {
		// let fData = new FormData();
		// fData.append('file', f);

		let fData = {"ApplicationHtml" : f }


		// let IData = new ImageData(200, 200);
		// IData.data = new Uint8ClampedArray(f.size);
		// 'Accept': 'application/json',
		const h = new Headers(
			{
				'Authorization': this._helperSrv.Authorization,
				'Access-Control-Allow-Origin': '*',
				'x-version': '1',
				'Content-Type': 'text/html',
				// 'Content-Length': f.size
			}
		);

		const options = new RequestOptions(
			{ headers: h }
		);

		const endPoint = this._helperSrv.ApiLocation +
			`AWS/S3/UploadAsync/application/${file.ApplicationNumber}/file/${file.Name}/ext/${file.Ext}/order/${file.Order}`;
		
		return this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, fData, options)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IAWSS3Model>body.Data;
					return data;
				} else {
					this._logSrv.Error(this.name, ['get file', response]);
					return undefined;
				}
			})
			.toPromise();
	}


	delete(fileModel: IAWSS3Model): Promise<IModel> {
		let url = fileModel.Links.find(l => l.Name === 'Delete').Href;


		// const indexOfDot = file.Name.lastIndexOf('.');
		// const ext = file.Name.substring(indexOfDot + 1);
		// const endPoint = this._helperSrv.ApiLocation +
		//   `AWS/S3/delete/application/${file.ApplicationNumber}/file/${file.Name.replace('.pdf','')}/ext/${ext}`;
		this._logSrv.Debug(this.name, ['delete file aws s3', url, fileModel]);
		return this._serverSrv.DeleteWithAuthWithURL(this._userSrv.Data.contact.AcepId, url)
			.map(response => {
				const body = response.json();
				const data = <IModel>body.Data;
				return data;
			})
			.toPromise();
	}

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/file/file.service.ts